import { render, staticRenderFns } from "./zone-carousel.vue?vue&type=template&id=bc777e26&scoped=true"
import script from "./zone-carousel.vue?vue&type=script&lang=js"
export * from "./zone-carousel.vue?vue&type=script&lang=js"
import style0 from "./zone-carousel.vue?vue&type=style&index=0&id=bc777e26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc777e26",
  null
  
)

export default component.exports